import { el, setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

class Option {

  constructor() {

    this.el = el('option');

  }

  update(option, index, options, context) {

    setAttr(this.el, {
      value: option
    });

    this.el.textContent = option;

    if (option === '') {

      this.el.textContent = context.placeholder;

    }

  }

}

export default Option;